import ImageWithFallback from "./ImageWithFallback.jsx";

export default function HairdresserSelect({ hairdressers, onSelect }) {
  return (
    <div className="space-y-3">
      {hairdressers.map((h) => {
        const count = (h.appointment_types || []).length;
        const servicesText = !count
          ? "Servicos a definir"
          : `${count} servico${count > 1 ? "s" : ""} disponiveis`;

        return (
          <button
            key={h.id}
            type="button"
            onClick={() => onSelect(h)}
            className="w-full flex items-center gap-4 p-4 bg-card border border-border rounded-lg hover:border-gold/50 transition-colors text-left"
          >
            {/* Avatar */}
            <div className="w-16 h-16 flex-shrink-0 rounded-full overflow-hidden border border-border">
              <ImageWithFallback
                src={h.image_url}
                alt={h.name ? `Foto de ${h.name}` : "Foto do profissional"}
                label="Profissional"
                variant="hairdresser"
                className="w-full h-full object-cover"
              />
            </div>

            {/* Info */}
            <div className="flex-1 min-w-0">
              <h3 className="text-lg font-semibold text-white mb-1 truncate">
                {h.name}
              </h3>
              <p className="text-sm text-muted">{servicesText}</p>
            </div>

            {/* Arrow */}
            <div className="text-gold text-xl flex-shrink-0">→</div>
          </button>
        );
      })}
    </div>
  );
}
